<lib-block-title
  id="device-registry-title"
  [title]="labels.deviceRegistryTitle">
</lib-block-title>
<div
  class="fx-col fx-gap-3"
  id="deviceRegistry-filter">
  <form
    *ngIf="filterForm"
    class="fx-row fx-wrap fx-gap-3"
    [formGroup]="filterForm">
    <div class="fx-col fx-gap-1 fx-align-start p-4 border-grey-200 border-1 radius-4 ">
      <mat-label class="text-grey-400">{{ labels.deviceFilters }}</mat-label>
      <div class="fx-row fx-gap-3 w-fit fx-wrap">
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="deviceId"
            [placeholder]="labels.deviceIdPlaceholder"
            (keydown.enter)="onSubmit()">
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <mat-select
            formControlName="type"
            [placeholder]="labels.deviceTypeFilterPlaceholder">
            <mat-option [value]="null">{{ labels.deviceTypeFilterPlaceholder }}</mat-option>
            <mat-option *ngFor="let option of deviceTypeOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <mat-select
            formControlName="batteryModel"
            [placeholder]="labels.batteryModelFilterPlaceholder">
            <mat-option [value]="null">{{ labels.batteryModelFilterPlaceholder }}</mat-option>
            <mat-option *ngFor="let option of batteryModelOptions" [value]="option.value">
              {{ option.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="fx-col fx-gap-1 w-fit p-4 border-grey-200 border-1 radius-4">
      <mat-label class="text-grey-400">{{ labels.firmwareFilters }}</mat-label>
      <div class="fx-row fx-gap-3 w-fit fx-wrap">
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="arm"
            [placeholder]="labels.armPlaceholder"
            (keydown.enter)="onSubmit()">
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="dspm"
            [placeholder]="labels.dspmPlaceholder"
            (keydown.enter)="onSubmit()">
        </mat-form-field>
        <mat-form-field
          subscriptSizing="dynamic"
          class="custom-mat-form-field custom-border-bottom">
          <input
            matInput
            formControlName="dsps"
            [placeholder]="labels.dspsPlaceholder"
            (keydown.enter)="onSubmit()">
        </mat-form-field>
      </div>
    </div>
    <div class="fx-col fx-gap-1 w-fit p-4 border-grey-200 border-1 radius-4">
      <mat-label class="text-grey-400">{{ labels.stateFilters }}</mat-label>
      <div class="fx-row fx-gap-3 w-fit fx-wrap">
        <mat-checkbox
          class="custom-checkbox"
          formControlName="isInAlarm">
          {{ labels.inAlarmFilterLabel }}
        </mat-checkbox>
        <mat-checkbox
          class="custom-checkbox"
          formControlName="hasAzzurroEvents">
          {{ labels.azzurroEventsFilterLabel }}
        </mat-checkbox>
      </div>
    </div>
  </form>
  <div
    class="fx-gap-3"
    style="display: flex; flex-direction: row-reverse;">
    <customer-simple-button
      [action]="onSubmit"
      [label]="labels.applyFilters">
    </customer-simple-button>
    <customer-simple-button
      type="warning"
      [label]="labels.resetFilters"
      [action]="resetFilter">
    </customer-simple-button>
  </div>
</div>

<azzurro-table
  *ngIf="paginationConfig | async as paginationConfig"
  id="deviceRegistry-table"
  [labels]="labels"
  [columns]="columns"
  [paginationConfig]="paginationConfig"
  [data$]="data$"
  [tableId]="'deviceRegistry'"
  [mode]="'server'"
  [showColumnToggleButton]="true"
  [pagination]="true"
  [noResultTemplate]="noResult"
  [filterEnabled]="false"
  (pageChanged)="onPageChange($event)"
  (sortChanged)="onSortChange($event)">
</azzurro-table>

<section
  id="deviceRegistry-list"
  class="fx-col radius-4 border-1 border-grey-100 radius-4 p-2">
  <div *ngIf="data$ | async as data; else skeleton">
    <div
      *ngFor="let device of data; let first = first; let odd = odd"
      class="fx-col fx-gap-2 p-2 radius-4"
      [class.bg-grey-100]="odd">
      <div class="fx-row fx-justify-between">
        <div class="fx-col fx-gap-1">
          <div class="tw-font-medium  tw-text-grey-400">
            {{ device.deviceId }}
          </div>
          <div
            *ngIf="device.batteryModel"
            class="tw-text-grey-400">
            {{ device.batteryModel }}
          </div>
        </div>
        <div class="tw-text-grey-400">
          {{ device.devType }}
        </div>
      </div>
      <div class="fx-row fx-gap-3">
        <div class="tw-text-grey-400">
          {{ device.arm }}
        </div>
        <div class="tw-text-grey-400">
          {{ device.dspm }}
        </div>
        <div class="tw-text-grey-400">
          {{ device.dsps }}
        </div>
      </div>
      <div class="fx-row fx-gap-3">
        <mat-chip
          *ngIf="device.isInAlarm"
          class="chip-level-2">
          {{ labels.isInAlarm }}
        </mat-chip>
        <mat-chip
          *ngIf="device.hasAzzurroEvents"
          class="chip-level-2">
          {{ labels.hasAzzurroEvents }}
        </mat-chip>
      </div>
      <div class="fx-row fx-gap-1">
        <button
          mat-icon-button
          [matTooltip]="labels.viewDevice"
          (click)="goToDevice.emit(device.deviceId); $event.stopPropagation()">
          <mat-icon class="text-accent">visibility</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <mat-paginator
    *ngIf="paginationConfig | async as paginationConfig"
    class="text-grey-400"
    [pageSizeOptions]="paginationConfig.pageSizeOptions || []"
    [pageSize]="paginationConfig?.pageSize"
    [length]="paginationConfig?.length"
    (page)="onPageChange($event)">
  </mat-paginator>
</section>

<ng-template #skeleton>
  <div
    *ngFor="let _ of [].constructor(10); let first = first"
    class="tw-flex tw-flex-col tw-p-2 tw-border-grey-100"
    [class.tw-border-t]="!first">
    <div class="fx-col fx-gap-1">
      <ion-skeleton-text
        *ngFor="let _ of [].constructor(3)"
        animated
        class="w-full h-10">
      </ion-skeleton-text>
    </div>
  </div>
</ng-template>

<ng-template #noResult>
  <div class="fx-col fx-center">
    <div class="tw-font-medium tw-text-base tw-text-grey-400">
      {{ labels.noResultsFound }}
    </div>
    <customer-simple-button
      type="warning"
      [label]="labels.resetFilters"
      [action]="resetFilter">
    </customer-simple-button>
  </div>
</ng-template>

<ng-template
  #deviceIdColumn
  let-row>
  <ngx-copy-to-clipboard
    class="w-full"
    position="right"
    [textToCopy]="row.deviceId">
    <span class="ellipsed">
      {{ row.deviceId }}
    </span>
  </ngx-copy-to-clipboard>
</ng-template>

<ng-template
  #actionsColumn
  let-row>
  <button
    mat-icon-button
    [matTooltip]="labels.viewDevice"
    (click)="goToDevice.emit(row.deviceId); $event.stopPropagation()">
    <mat-icon class="text-accent">visibility</mat-icon>
  </button>
</ng-template>